import { useMemo } from 'react';
import { trpc } from '@/lib/trpc';
import { useAppSelector } from '@/stores/hooks';
import type { AiChatPanelMode, EnabledAiModel } from '../types';
import { composeApiModelId } from '../utils/model-id';

export function useAiModels(mode: AiChatPanelMode) {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const isHydrated = useAppSelector((s) => s.auth.isHydrated);

  const modelType =
    mode === 'CHAT' ? 'CHAT' : mode === 'IMAGE' ? 'IMAGE' : mode === 'VIDEO' ? 'VIDEO' : 'AVATAR';

  const { data, isLoading } = trpc.aiModel.listEnabled.useQuery(
    { modelType },
    { enabled: isHydrated && isAuthenticated && (mode === 'CHAT' || mode === 'IMAGE') }
  );

  const models = useMemo(() => (data ?? []) as EnabledAiModel[], [data]);

  const modelsWithApiId = useMemo(
    () =>
      models.map((m) => ({
        ...m,
        apiModelId: m.modelCode ? composeApiModelId(m.modelCode, m.modelVersion) : '',
        label: m.modelName || m.modelCode || m.id,
      })),
    [models]
  );

  return { models: modelsWithApiId, isLoading };
}
